<mat-sidenav-container class="sidenav-container" [class.expanded]="isExpanded()">
  <mat-sidenav #sidenav mode="side" class="custom-sidenav" [class.expanded]="isExpanded()" [disableClose]="true" opened>
    <mat-nav-list class="nav-list-container">
      <div class="top-section">
        <a mat-list-item disableRipple routerLink="/campaigns" class="logo nav-button">
          <img src="images/logo/logo.png" alt="Shikenso" width="20" priority />
        </a>

        <button type="button" class="toggle-btn" (click)="toggleSidebar()" aria-label="Toggle sidebar">
          <app-icon src="/icons/sidebar.svg" alt="Collapse" class="w-4 h-4" />
        </button>
      </div>

      <div class="middle-section">
        <div class="multiple-nav-items">
          <a
            mat-list-item
            disableRipple
            routerLink="/dashboard"
            routerLinkActive
            class="nav-item nav-button"
            matTooltipPosition="right"
            [activated]="rla1.isActive"
            [matTooltip]="'pages.dashboard.banner.title' | translate"
            [matTooltipDisabled]="isExpanded()"
            [matTooltipShowDelay]="100"
            [matTooltipHideDelay]="50"
            #rla1="routerLinkActive"
            *hasPermission="[EPermissions.newsReadAll, EPermissions.newsReadOwn]"
          >
            <app-icon
              src="/icons/dashboard.svg"
              alt="Dashboard"
              class="pointer-events-none w-4 h-4"
              [class.invert]="rla1.isActive"
            />

            @if (isExpanded()) {
              <span class="nav-label" [class.!text-shikenso-base-white]="rla1.isActive">
                {{ 'pages.dashboard.banner.title' | translate }}
              </span>
            }
          </a>

          <a
            mat-list-item
            disableRipple
            routerLink="/campaigns"
            routerLinkActive
            class="nav-item nav-button"
            matTooltipPosition="right"
            [activated]="rla2.isActive"
            [matTooltip]="'shared.campaigns' | translate"
            [matTooltipDisabled]="isExpanded()"
            [matTooltipShowDelay]="100"
            [matTooltipHideDelay]="50"
            [routerLinkActiveOptions]="{ exact: true }"
            #rla2="routerLinkActive"
            *hasPermission="[EPermissions.campaignReadOwn]"
          >
            <app-icon src="/icons/campaigns.svg" alt="Campaigns" class="w-4 h-4" [class.invert]="rla2.isActive" />

            @if (isExpanded()) {
              <span class="nav-label" [class.!text-shikenso-base-white]="rla2.isActive">
                {{ 'shared.campaigns' | translate }}
              </span>
            }
          </a>

          <a
            mat-list-item
            disableRipple
            routerLink="/creators"
            routerLinkActive
            class="nav-item nav-button"
            matTooltipPosition="right"
            [activated]="rla4.isActive"
            [matTooltip]="'pages.creators.banner.title' | translate"
            [matTooltipDisabled]="isExpanded()"
            [matTooltipShowDelay]="100"
            [matTooltipHideDelay]="50"
            #rla4="routerLinkActive"
            *hasPermission="[EPermissions.creatorReadOwn]"
          >
            <app-icon src="/icons/creators.svg" alt="Creators" class="w-4 h-4" [class.invert]="rla4.isActive" />

            @if (isExpanded()) {
              <span class="nav-label" [class.!text-shikenso-base-white]="rla4.isActive">
                {{ 'pages.creators.banner.title' | translate }}
              </span>
            }
          </a>

          @if ((authService.currentDbUser$ | async)?.creatorId) {
            <a
              mat-list-item
              disableRipple
              routerLink="/creator"
              routerLinkActive
              class="nav-item nav-button"
              matTooltipPosition="right"
              [activated]="rla8.isActive"
              [matTooltip]="'shared.creator' | translate"
              [matTooltipDisabled]="isExpanded()"
              [matTooltipShowDelay]="100"
              [matTooltipHideDelay]="50"
              #rla8="routerLinkActive"
              *hasPermission="[EPermissions.creatorReadSelf]"
            >
              <app-icon src="/icons/user-profile.svg" alt="Creator" class="w-4 h-4" [class.invert]="rla8.isActive" />

              @if (isExpanded()) {
                <span class="nav-label" [class.!text-shikenso-base-white]="rla8.isActive">
                  {{ 'shared.creator' | translate }}
                </span>
              }
            </a>
          }

          <a
            mat-list-item
            disableRipple
            routerLink="/customers"
            routerLinkActive
            class="nav-item nav-button"
            matTooltipPosition="right"
            [activated]="rla5.isActive"
            [matTooltip]="'pages.customers.banner.title' | translate"
            [matTooltipDisabled]="isExpanded()"
            [matTooltipShowDelay]="100"
            [matTooltipHideDelay]="50"
            #rla5="routerLinkActive"
            *hasPermission="EPermissions.customerReadOwn"
          >
            <app-icon src="/icons/customers.svg" alt="Customers" class="w-4 h-4" [class.invert]="rla5.isActive" />

            @if (isExpanded()) {
              <span class="nav-label" [class.!text-shikenso-base-white]="rla5.isActive">
                {{ 'pages.customers.banner.title' | translate }}
              </span>
            }
          </a>

          <!-- Admin navigations separator -->
          <hr
            class="separator"
            *hasPermissionGroups="[
              [EPermissions.campaignAnalyticsReadAll],
              [EPermissions.campaignReadAll],
              [EPermissions.userFeedbackReadAll, EPermissions.userReadAll],
              [EPermissions.userGroupReadAll],
              [EPermissions.userReadAll],
            ]"
          />

          <a
            mat-list-item
            disableRipple
            routerLink="/admin/user-group"
            routerLinkActive
            class="nav-item nav-button"
            matTooltipPosition="right"
            [activated]="rlaAdminUserGroup.isActive"
            [matTooltip]="'pages.admin.userGroup.navigationTitle' | translate"
            [matTooltipDisabled]="isExpanded()"
            [matTooltipShowDelay]="100"
            [matTooltipHideDelay]="50"
            #rlaAdminUserGroup="routerLinkActive"
            *hasPermission="[EPermissions.userGroupReadAll, EPermissions.userReadAll]"
          >
            <app-icon
              src="/icons/user-cog.svg"
              alt="User Group Admin"
              class="w-4 h-4"
              [class.invert]="rlaAdminUserGroup.isActive"
            />
            <div class="admin-badge" [class.invert]="rlaAdminUserGroup.isActive">A</div>

            @if (isExpanded()) {
              <span class="nav-label" [class.!text-shikenso-base-white]="rlaAdminUserGroup.isActive">
                {{ 'pages.admin.userGroup.navigationTitle' | translate }}
              </span>
            }
          </a>

          <a
            mat-list-item
            disableRipple
            routerLink="/admin/campaigns"
            routerLinkActive
            class="nav-item nav-button"
            matTooltipPosition="right"
            [activated]="rlaAdminCampaigns.isActive"
            [matTooltip]="'pages.admin.adminCampaigns.navigationTitle' | translate"
            [matTooltipDisabled]="isExpanded()"
            [matTooltipShowDelay]="100"
            [matTooltipHideDelay]="50"
            #rlaAdminCampaigns="routerLinkActive"
            *hasPermission="[EPermissions.campaignAnalyticsReadAll, EPermissions.campaignReadAll]"
          >
            <app-icon
              src="/icons/campaigns.svg"
              alt="Campaigns Admin"
              class="w-4 h-4"
              [class.invert]="rlaAdminCampaigns.isActive"
            />
            <div class="admin-badge" [class.invert]="rlaAdminCampaigns.isActive">A</div>

            @if (isExpanded()) {
              <span class="nav-label" [class.!text-shikenso-base-white]="rlaAdminCampaigns.isActive">
                {{ 'pages.admin.adminCampaigns.navigationTitle' | translate }}
              </span>
            }
          </a>

          <a
            mat-list-item
            disableRipple
            routerLink="/admin/user-feedback"
            routerLinkActive
            class="nav-item nav-button"
            matTooltipPosition="right"
            [activated]="rlaAdminUserFeedback.isActive"
            [matTooltip]="'pages.admin.userFeedback.navigationTitle' | translate"
            [matTooltipDisabled]="isExpanded()"
            [matTooltipShowDelay]="100"
            [matTooltipHideDelay]="50"
            #rlaAdminUserFeedback="routerLinkActive"
            *hasPermission="[EPermissions.userFeedbackReadAll, EPermissions.userReadAll]; requireAll: true"
          >
            <app-icon
              src="/icons/user-feedback.svg"
              alt="User Feedback Admin"
              class="w-4 h-4"
              [class.invert]="rlaAdminUserFeedback.isActive"
            />
            <span class="admin-badge" [class.invert]="rlaAdminUserFeedback.isActive"> A </span>

            @if (isExpanded()) {
              <span class="nav-label" [class.!text-shikenso-base-white]="rlaAdminUserFeedback.isActive">
                {{ 'pages.admin.userFeedback.navigationTitle' | translate }}
              </span>
            }
          </a>

          <a
            mat-list-item
            disableRipple
            routerLink="/admin/news"
            routerLinkActive
            class="nav-item nav-button"
            matTooltipPosition="right"
            [activated]="rlaAdminNews.isActive"
            [matTooltip]="'pages.admin.news.navigationTitle' | translate"
            [matTooltipDisabled]="isExpanded()"
            [matTooltipShowDelay]="100"
            [matTooltipHideDelay]="50"
            #rlaAdminNews="routerLinkActive"
            *hasPermission="[EPermissions.newsReadAll]"
          >
            <app-icon src="/icons/news.svg" alt="News Admin" class="w-4 h-4" [class.invert]="rlaAdminNews.isActive" />
            <span class="admin-badge" [class.invert]="rlaAdminNews.isActive"> A </span>

            @if (isExpanded()) {
              <span class="nav-label" [class.!text-shikenso-base-white]="rlaAdminNews.isActive">
                {{ 'pages.admin.news.navigationTitle' | translate }}
              </span>
            }
          </a>

          <a
            mat-list-item
            disableRipple
            routerLink="/admin/usage-adoption"
            routerLinkActive
            class="nav-item nav-button"
            matTooltipPosition="right"
            [activated]="rlaAdminEventAnalytics.isActive"
            [matTooltip]="'pages.admin.eventAnalytics.navigationTitle' | translate"
            [matTooltipDisabled]="isExpanded()"
            [matTooltipShowDelay]="100"
            [matTooltipHideDelay]="50"
            #rlaAdminEventAnalytics="routerLinkActive"
            *hasPermission="[EPermissions.userReadAll]"
          >
            <app-icon
              src="/icons/analytics.svg"
              alt="Usage & Adoption Admin"
              class="w-4 h-4"
              [class.invert]="rlaAdminEventAnalytics.isActive"
            />
            <div class="admin-badge" [class.invert]="rlaAdminEventAnalytics.isActive">A</div>

            @if (isExpanded()) {
              <span class="nav-label" [class.!text-shikenso-base-white]="rlaAdminEventAnalytics.isActive">
                {{ 'pages.admin.eventAnalytics.navigationTitle' | translate }}
              </span>
            }
          </a>

          <!-- Settings navigation separator -->
          <hr class="separator" *hasPermissionGroups="settingsAccessPermissionGroups" />

          <a
            mat-list-item
            disableRipple
            routerLink="/account-panel"
            routerLinkActive
            class="nav-item nav-button bottom-buttons"
            matTooltipPosition="right"
            [activated]="rla6.isActive"
            [matTooltip]="'pages.settings.accountPanel' | translate"
            [matTooltipDisabled]="isExpanded()"
            [matTooltipShowDelay]="100"
            [matTooltipHideDelay]="50"
            #rla6="routerLinkActive"
            *hasPermissionGroups="settingsAccessPermissionGroups"
          >
            <app-icon src="/icons/settings.svg" alt="Account Panel" class="w-4 h-4" [class.invert]="rla6.isActive" />

            @if (isExpanded()) {
              <span class="nav-label" [class.!text-shikenso-base-white]="rla6.isActive">
                {{ 'pages.settings.accountPanel' | translate }}
              </span>
            }
          </a>
        </div>
      </div>

      <div class="bottom-section">
        <app-ai-connector-teaser class="w-full" [expanded]="isExpanded()" />

        <app-user-group-select class="w-full mb-2" />

        <hr class="separator pb-4" />

        <div class="multiple-nav-items">
          <a
            mat-list-item
            disableRipple
            routerLink="/profile"
            routerLinkActive
            matTooltipPosition="right"
            class="nav-item-profile nav-button bottom-buttons"
            [matTooltip]="'pages.profile.banner.title' | translate"
            [matTooltipDisabled]="isExpanded()"
            [matTooltipShowDelay]="100"
            [matTooltipHideDelay]="50"
          >
            <app-icon-badge
              [content]="(authService.currentDbUser$ | async)?.iconId ?? 'icons/user.svg'"
              [fallbackText]="(authService.currentDbUser$ | async)?.name"
              [iconSize]="(authService.currentDbUser$ | async)?.iconId ? 40 : 32"
              [size]="40"
              [fontSize]="16"
              [backgroundColor]="
                (authService.currentDbUser$ | async)?.iconId ? 'var(--shikenso-pink-800)' : 'transparent'
              "
            />

            @if (isExpanded()) {
              <div class="flex w-full justify-between items-center">
                <div class="flex flex-col gap-0.5">
                  <span class="nav-label !opacity-60 !text-xs !text-shikenso-purple-base">
                    {{ 'shared.welcomeBack' | translate }}
                  </span>
                  <span class="nav-label !opacity-90 !font-bold leading-[20px]">
                    {{ userName ?? ('pages.profile.banner.title' | translate) }}
                  </span>
                </div>

                <app-icon src="/icons/chevron-right.svg" alt="Chevron Right" class="w-4 h-4" />
              </div>
            }
          </a>
        </div>
      </div>
    </mat-nav-list>
  </mat-sidenav>
</mat-sidenav-container>
